export const UserCenter = {
  title: "用户中心",
  child: [
    { title: "账号信息", pathName: "account" },
    { title: "需求发布管理", pathName: "myDemand" },
    { title: "我的消息", pathName: "myMessage" },
    // { title: "我的收藏", pathName: "myCollect" },
    { title: "我的订单", pathName: "strictMallTrustDeed" },
    // { title: "发票管理", pathName: "billManage" },
    { title: "地址管理", pathName: "addressManage" },
    // { title: "我参与的培训", pathName: "userCenterOnlineTrain" },
    { title: "申请入驻为专家", pathName: "expertRegister" },
  ],
};

export const MallManage = {
  title: "商城管理",
  auth: "mallManage",
  child: [
    // {
    //   title: "发票管理",
    //   pathName: "mallBillManage",
    //   auth: "mallBillManage",
    //   parentAuth: "mallManage",
    // },
    {
      title: "订单管理",
      pathName: "strictMallDeed",
      auth: "mallDeedManage",
      parentAuth: "mallManage",
    },
    {
      title: "商城服务管理",
      pathName: "strictServiceManage",
      auth: "mallServiceManage",
      parentAuth: "mallManage",
    },
    // {
    //   title: "服务商城标准管理",
    //   pathName: "standardManage",
    //   auth: "mallStandardManage",
    //   parentAuth: "mallManage",
    // },
    // {
    //   title: "商城订单管理",
    //   pathName: "superMallOrderManage",
    //   auth: "mallOrderdManage",
    //   parentAuth: "mallManage",
    // },
    // {
    //   title: "商城商品管理",
    //   pathName: "superMallGoodsManage",
    //   auth: "mallGoodsManage",
    //   parentAuth: "mallManage",
    // },
  ],
};

export const LabManage = {
  title: "实验室管理",
  auth: "labManage",
  child: [
    {
      title: "实验室账号管理",
      pathName: "labAccountManage",
      auth: "labAccountManage",
      parentAuth: "labManage",
    },
    {
      title: "实验室信息管理",
      pathName: "labInfoManage",
      auth: "labInfoManage",
      parentAuth: "labManage",
    },
    {
      title: "实验室能力维护",
      pathName: "labAbilityManage",
      auth: "labAbilityManage",
      parentAuth: "labManage",
    },
    {
      title: "实验室设备维护",
      pathName: "labDeviceManage",
      auth: "labDeviceManage",
      parentAuth: "labManage",
    },
  ],
};
export const EnterpriseCenter = {
  title: "企业中心",
  auth: "enterpriseCenter",
  child: [
    {
      title: "企业信息管理",
      pathName: "enterpriseInfo",
      auth: "enterpriseInfo",
      parentAuth: "enterpriseCenter",
    },
    {
      title: "企业账号管理",
      pathName: "enterpriseAccount",
      auth: "enterpriseAccount",
      parentAuth: "enterpriseCenter",
    },
  ],
};

export const ExpertCentr = {
  title: "专家中心",
  child: [
    {
      title: "申请评估管理",
      pathName: "applyEstimate",
    },
  ],
};
